import React from "react";
import { useStore } from "effector-react";
import {
  changeSelectedAccountIdx,
  changeSelectedAccountId,
  $accounts,
} from "../../../common/accounts2";
import { $companies } from "../../../common/companies2";
import { cutText } from "../../../common/functions";
import { getCustomUserAgent, getCustomUserAgentASB } from "../../../common/customUserAgent";
interface IAccountListItem {
  setAccShown: React.Dispatch<React.SetStateAction<boolean>>; //для установки состояние видимости списка аккаунтов
  accountIdx: number; //индекс текущего аккаунта
  accountId: number; //идентификатор текущего аккаунта
  accountNum: string; //номер текущего аккаунта
  addressOrOwnerFIO: string; //адрес
  companyId: number; //идентифкатор компании, к которой относиться текущий аккаунт
  sameAcc: number; //идентификатор выбранного аккаунта
}

export const AccountListItem = ({
  setAccShown,
  accountIdx,
  accountId,
  accountNum,
  addressOrOwnerFIO,
  companyId,
  sameAcc,
}: IAccountListItem) => {
  const [sameId, setSameId] = React.useState(false);

  const companies = useStore($companies); //компании пользователя
  const accounts = useStore($accounts)

  React.useEffect(() => {
    if (sameAcc === accountId) setSameId(true);
    return () => setSameId(false);
  }, [sameAcc, accountId]);

  const setAccount = () => {
    setAccShown(true); //показываем список акаунтов
    changeSelectedAccountIdx(accountIdx); //меняем индекс текущего аккаунта
    changeSelectedAccountId(accountId); //меняем идентифкатор текущего аккаунта
  };

  const getCompanyName = (comid: number) => {
    for (let i = 0, len = companies.length; i < len; ++i)
      if (+companies[i].id === comid) return companies[i].name;
    return "";
  };

  return !sameId ? (
    <li className="data-card__accs" onClick={setAccount}>
      <h4 className="data-card__title data-card__title_number data-card__title_other">
        <small>{cutText(accountNum, 12, '...', '')}</small>
      </h4>
      <p className="data-card__adress">{addressOrOwnerFIO}</p>
      <p className="data-card__company">
        {getCustomUserAgent()===getCustomUserAgentASB()?accounts.accounts[accountIdx].ownerFio:getCompanyName(companyId)}
      </p>
    </li>
  ) : (
    <></>
  );
};
